import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { GET_TRANSACTION, DELETE_TRANSACTION, UPDATE_TRANSACTION, ADD_NEW_TRANSACTION, GET_TRANSACTION_ONE } from "./actionType";

import { getTransactionSuccess, getTransactionFail, deleteTransactionSuccess, deleteTransactionFail, updateTransactionSuccess, updateTransactionFail, addTransactionSuccess, addTransactionFail } from "./action";

//Include Both Helper File with needed methods
import { approveTransactionApi, getTransactionApi, updateTransactionApi, deleteTransactionApi, addNewTransactionApi, getOneTransactionApi } from "../../helpers/backend_helper";

function* getTransaction({ payload: transaction }) {
  try {
    const response = yield call(getTransactionApi, transaction);
    yield put(getTransactionSuccess(GET_TRANSACTION, response.data));
  } catch (error) {
    yield put(getTransactionFail(GET_TRANSACTION, error));
  }
}

function* getTransactionOne({ payload: id }) {
  
  try {
    const response = yield call(getOneTransactionApi, id);
    yield put(getTransactionSuccess(GET_TRANSACTION_ONE, response));
  } catch (error) {
    yield put(getTransactionFail(GET_TRANSACTION_ONE, error));
  }
}

function* onUpdateTransaction({ payload: transaction }) {
  try {
    if (transaction.setApprove) {
      const response = yield call(approveTransactionApi, transaction);
      yield put(updateTransactionSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    } else {
      const response = yield call(updateTransactionApi, transaction);
      yield put(updateTransactionSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateTransactionFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteTransaction({ payload: transaction }) {
  try {
    const response = yield call(deleteTransactionApi, transaction);
    yield put(deleteTransactionSuccess({ transaction, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteTransactionFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewTransaction({ payload: transaction }) {
  try {
    const response = yield call(addNewTransactionApi, transaction);
    yield put(addTransactionSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addTransactionFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

export function* watchGetTransaction() {
  yield takeEvery(GET_TRANSACTION, getTransaction);
}

export function* watchGetTransactionOne() {
  yield takeEvery(GET_TRANSACTION_ONE, getTransactionOne);
}

export function* watchUpdateTransaction() {
  yield takeEvery(UPDATE_TRANSACTION, onUpdateTransaction);
}

export function* watchDeleteTransaction() {
  yield takeEvery(DELETE_TRANSACTION, onDeleteTransaction);
}

export function* watchAddNewTransaction() {
  yield takeEvery(ADD_NEW_TRANSACTION, onAddNewTransaction);
}

function* transactionSaga() {
  yield all([fork(watchGetTransaction), fork(watchGetTransactionOne), fork(watchDeleteTransaction), fork(watchUpdateTransaction), fork(watchAddNewTransaction)]);
}

export default transactionSaga;
